import type { FC } from 'react';

import { useInsightsTracking } from '@xing-com/crate-insights-tracking';
import { CarouselSection } from '@xing-com/crate-x4e-carousel-section';
import { ContentCard } from '@xing-com/crate-x4e-content-card';

import type { InsightsArticleFragment } from '../../graphql/insights-article.fragment.gql-types';

import { RegistrationCard } from './components/registration-card';

export const JobsCarouselSection: FC<{
  articles?: InsightsArticleFragment[];
}> = ({ articles }) => {
  const { trackWithNWT } = useInsightsTracking();

  const filteredArticles = articles?.filter((article) => {
    const { details } = article;
    return Boolean(details?.title) || Boolean(details?.image);
  });

  return (filteredArticles?.length ?? 0) > 0 ? (
    <CarouselSection
      titleKey="INSIGHTS_LO_JOBSEEKER_SECTION_TITLE"
      subtitleKey="INSIGHTS_LO_JOBSEEKER_SECTION_SUBTITLE"
    >
      {filteredArticles?.map((props, index) => {
        const { objectUrn, category, details } = props ?? {};
        const { url } = details ?? {};
        const trackedUrl = `${url}?sc_o=insights_job_search_articles_module_${category?.toLowerCase()}_click&sc_o_PropActionOrigin=discover_update_InsightsJobSearchArticlesModule`;

        const trackArticle = (e?: MouseEvent): void =>
          trackWithNWT({
            event: e ? 'opened' : 'entered_viewport',
            element: 'job_search_article',
            element_detail: category?.toLowerCase(),
            itemUrn: objectUrn ?? '',
            moduleTitle: 'discover_insights_job_search_articles',
            position: index + 14,
            verticalPosition: 4,
            modulePosition: 4,
            positionInModule: index + 1,
          });

        return (
          <ContentCard
            key={objectUrn}
            to={trackedUrl}
            // @ts-expect-error FIXME: SC6
            onClick={trackArticle}
            onEnter={trackArticle}
            {...props}
            {...details}
          />
        );
      })}
      <RegistrationCard
        positionInModule={articles ? articles?.length + 1 : undefined}
      />
    </CarouselSection>
  ) : null;
};
